<div id="table">
    <div class="pt-8">

        <div class="example-viewer-body">
            <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
                <mat-label>Search</mat-label>
                <input type="text" matInput #filter >
            </mat-form-field>
            <!-- CONTENT CARD -->
            <div class="mat-elevation-z8">

                <mat-table class=""
                           #table [dataSource]="dataSource"
                           matSort
                           [@animateStagger]="{value:'50'}"
                           fusePerfectScrollbar>

                    <ng-container matColumnDef="supplier">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.lg fxShow.md>Code</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxHide fxShow.lg fxShow.md>
                            <p class="text-truncate">{{result.supplier.short_name}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="vessel">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Vessel</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                            <p class="text-truncate">{{result.vessel.name}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Voyage</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                            <p class="text-truncate">{{result.name}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="depart_time">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Depart time</mat-header-cell>
                        <mat-cell *matCellDef="let result">
                            <p class="text-truncate">{{result.depart_time | date: 'EEE, MMM d,y'}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="arrive_time">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.lg fxShow.md>Arrive time</mat-header-cell>
                        <mat-cell *matCellDef="let result"  fxHide fxShow.lg fxShow.md>
                            <p class="text-truncate">{{result.arrive_time | date: 'EEE, MMM d,y'}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="transit_time">
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.lg fxShow.md>Transit time</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxHide fxShow.lg fxShow.md>
                            <p class="text-truncate">{{result.transit_time}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="unit" >
                        <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.sm fxShow.lg fxShow.md>Unit support</mat-header-cell>
                        <mat-cell *matCellDef="let result" fxHide fxShow.sm fxShow.lg fxShow.md>
                            <mat-chip-list>
                              <mat-chip color="accent" selected *ngFor="let item of result.units" (click)="getVoyage(result, item)">{{item}}</mat-chip>
                            </mat-chip-list>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                    <mat-row *matRowDef="let result; columns: displayedColumns;"
                             class="country-list"
                             matRipple
                             (click)="getVoyage(result)"
                             >
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator
                               [length]="dataSource.filteredData.length"
                               [pageIndex]="0"
                               [pageSize]="10"
                               [pageSizeOptions]="[5, 10, 25, 100]">
                </mat-paginator>

            </div>
        </div>
    </div>
</div>
